import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  IAlert,
  AlertContainer,
  Faq,
  IAlertsResponse,
  IApiFaqResponse,
  WhatsNew,
} from '../models';

/**
 * AlertService to handle alerts related functionality
 */
@Injectable()
export class AlertService extends BaseApiService {
  private publicHomeCmsPageId = 'homepage';

  private alertKeySubject = new BehaviorSubject<string | null>(null);
  alertKey$ = this.alertKeySubject.asObservable();

  /**
   * Creates an instance of alert service.
   * @param injector require for BaseApiService
   */
  constructor(protected injector: Injector) {
    super(injector);
  }

  get baseAlertUrl(): string {
    return `${environment.baseApiUrls}/alerts`;
  }

  get baseAlertUrlBP(): string {
    return `${this.endPointBP}/alerts`;
  }

  // Set a new alert key
  setAlertKey(key: string | null): void {
    this.alertKeySubject.next(key);
  }

  /**
   * Gets the alerts stream from the backend
   * @returns observable of alerts array
   */
  public getAlerts(pageId: string): Observable<IAlert[]> {
    if (pageId === this.publicHomeCmsPageId) {
      return this.httpGet<IAlertsResponse>(this.baseAlertUrl).pipe(
        map(data => data.alerts)
      );
    } else {
      const url = `${this.baseAlertUrlBP}/page/${pageId}`;
      return this.httpAuthGet<IAlertsResponse>(url).pipe(
        map(data => data.alerts)
      );
    }
  }


  public getAllAlerts(): Observable<IAlert[]> {
      const url = `${this.baseAlertUrlBP}`;
      return this.httpAuthGet<IAlertsResponse>(url).pipe(
        map(data => data.alerts)
      );
  }


  public getAlertContainer(
    containerPageUid: string
  ): Observable<AlertContainer> {
    const url = `${this.baseAlertUrl}/alert/${containerPageUid}`;
    return this.httpGet<AlertContainer>(url);
  }

  public getWhatsNew(): Observable<WhatsNew> {
    const url = `${this.baseAlertUrl}/whatsnew`;
    return this.httpGet<WhatsNew>(url);
  }

  public getFaq(): Observable<Faq[]> {
    const url = `${this.baseAlertUrl}/faq`;
    return this.httpGet<IApiFaqResponse>(url).pipe(map(data => data.faqs));
  }
}
